const rankings = [
  { rank: 1, title: '某顶流男星出轨事件全记录', heat: '982.3万', trend: 'up', change: '+128万' },
  { rank: 2, title: '知名女星婚变内幕连环曝光', heat: '876.5万', trend: 'up', change: '+95万' },
  { rank: 3, title: '综艺节目翻车现场全记录', heat: '754.2万', trend: 'up', change: '+67万' },
  { rank: 4, title: '当红小生人设崩塌始末追踪', heat: '689.7万', trend: 'down', change: '-23万' },
  { rank: 5, title: '选秀节目黑幕大起底', heat: '621.3万', trend: 'up', change: '+156万' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            吃瓜热度榜
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            实时更新的吃瓜热度排名，看看今天全网最火的是什么瓜
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-lg overflow-hidden">
            {rankings.map((item, i) => (
              <div
                key={i}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-primary-50/50 transition-colors ${
                  i < rankings.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-300 text-primary-900'
                    : item.rank === 3
                    ? 'bg-accent-400 text-accent-950'
                    : 'bg-secondary-200 text-secondary-700'
                }`}>
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground-800 truncate">
                    {item.title}
                  </p>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                  <span className="text-xs text-foreground-400">{item.heat}</span>
                  <span className={`text-xs font-medium whitespace-nowrap ${
                    item.trend === 'up' ? 'text-primary-600' : 'text-secondary-500'
                  }`}>
                    <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} mr-0.5`}></i>
                    {item.change}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}